import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CustomersIcon from "@mui/icons-material/Business";
import SuppliersIcon from "@mui/icons-material/Handshake";
import CloseIcon from "@mui/icons-material/Close";
import LogoutIcon from "@mui/icons-material/Logout";
import SalesIcon from "@mui/icons-material/Sell";
import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { logoutUser } from "../redux/auth";
import { selectCanEditChartOfAccounts } from "../redux/auth";

const MainMenu = (props) => {
  const dispatch = useDispatch();

  const onLogout = () => dispatch(logoutUser());

  const canEditChartOfAccounts = useSelector(selectCanEditChartOfAccounts);
  const canViewAccounting = canEditChartOfAccounts;

  return (
    <Drawer open={props.open} anchor="left" onClose={props.onClose}>
      <Stack className={props.className} direction="column">
        <Toolbar className="Toolbar">
          <div className="LogoContainer">
            <Typography className="Logo">AZLedger</Typography>
          </div>
          <IconButton onClick={props.onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <MenuItem
          component={RouterLink}
          onClick={props.onClose}
          to="/customers"
        >
          <ListItemIcon>
            <CustomersIcon />
          </ListItemIcon>
          Customers
        </MenuItem>
        <MenuItem
          component={RouterLink}
          onClick={props.onClose}
          to="/suppliers"
        >
          <ListItemIcon>
            <SuppliersIcon />
          </ListItemIcon>
          Suppliers
        </MenuItem>
        <MenuItem component={RouterLink} onClick={props.onClose} to="/sales">
          <ListItemIcon>
            <SalesIcon />
          </ListItemIcon>
          Sales
        </MenuItem>
        {canViewAccounting && <Divider />}
        {canEditChartOfAccounts && (
          <MenuItem
            component={RouterLink}
            onClick={props.onClose}
            to="/accounting/coa"
          >
            <ListItemIcon>
              <AccountTreeIcon />
            </ListItemIcon>
            Chart of Accounts
          </MenuItem>
        )}
        <Divider />
        <MenuItem component={RouterLink} onClick={props.onClose} to="/settings">
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          Settings
        </MenuItem>
        <Divider />
        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          Logout
        </MenuItem>
        <Box className="MenuFooter">
          AZLedger &copy; {new Date().getFullYear()}
          <br />v{process.env.REACT_APP_VERSION}
        </Box>
      </Stack>
    </Drawer>
  );
};

export default styled(MainMenu)(
  ({ theme }) => `
  height: 100%;
  width: 250px;
  padding: 0px 0px 15px 0px;

  .LogoContainer {
    flex-grow: 1;
  }

  .Logo {
    background: linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${theme.palette.primary.main} 95%);
    display: inline;
    font-family: milliard-medium;
    font-size: 20px;
    font-weight: 700;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .MenuFooter {
    align-items: end;
    display: flex;
    flex-grow: 1;
    font-size: 14px;
    justify-content: center;
    text-align: center;
  }

  .MuiDivider-root {
    margin: 10px;
  }

  .Toolbar {
    background-image: linear-gradient(90deg, ${theme.palette.secondary.main} 30%, ${theme.palette.primary.main} 95%);
    background-size: 100% 5px;
    background-position: right 100%;
    background-repeat: no-repeat;
  }
`,
);
